import { useDecodeArrayBuffer } from './useDecodeArrayBuffer'
import { useCallback } from 'react'
import { readBlobAsArrayBuffer } from '../functions/readBlobAsArrayBuffer'

export function useDecodeAudioFile() {
  const decodeArrayBuffer = useDecodeArrayBuffer()

  return useCallback(
    (file: File): Promise<AudioBuffer> =>
      readBlobAsArrayBuffer(file).then((arrayBuffer) => decodeArrayBuffer(arrayBuffer, file.name)),
    [decodeArrayBuffer],
  )
}
